import { render, staticRenderFns } from "./TreatmentDetail.vue?vue&type=template&id=6627f0bb&lang=pug"
import script from "./TreatmentDetail.vue?vue&type=script&lang=js"
export * from "./TreatmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports